<template>
  <div>
    <b-container class="mt-5 mb-5">
      <h1 class="fs-4 font-weight-bold mb-4">Teamlid toevoegen</h1>
      
      <ValidationObserver ref="form" slim>
        <b-card class="mb-3">
          <b-row>
            <b-col md="6">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <div class="mb-3">
                  <label class="required">Voornaam</label>
                  <b-form-input v-model="form.firstname" />
                  <div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
                </div>
              </ValidationProvider>
            </b-col>

            <b-col md="6">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <div class="mb-3">
                  <label class="required">Achternaam</label>
                  <b-form-input v-model="form.lastname "/>
                  <div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
                </div>
              </ValidationProvider>
            </b-col>
          </b-row>

          <div class="mb-3">
            <font-awesome-icon @click="toggleInfo()" icon="fa-solid fa-info-circle" class="text-primary cursor-pointer mr-2"/>
            <label class="required">Rol</label>
            <b-form-select v-model="form.role" :options="roleOptions" />
          </div>

          <b-alert variant="secondary" show v-if="showExplainRoles">
            <h5>Uitleg rollen</h5>
            <ul class="list-unstyled">
              <li><strong>Geen:</strong> Kan inloggen, maar heeft (nog) geen verdere toegang.</li>
              <li><strong>Administrator:</strong> Heeft volledig beheer over het systeem.</li>
              <li><strong>Manager:</strong> Heeft volledig beheer over één of meerdere locaties.</li>
              <li><strong>Servicemedewerker:</strong> Heeft toegang tot klantgegevens en tickets voor één of meerdere locaties, met de mogelijkheid deze te beheren.</li>
              <li><strong>Scan- en kassamedewerker:</strong> Kan voor één of meerdere locaties tickets controleren en/of scannen.</li>
            </ul>
          </b-alert>
          
          <div class="mb-3" v-if="form.role == 'manager' || form.role == 'service' || form.role == 'scanner'">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="mb-3">
                <label class="required">Locaties</label>
                <b-form-multiselect v-model="form.locations" :options="locationsOptions" @change="filterEvents()" />
                <div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
              </div>
            </ValidationProvider>

            <div class="mb-3">
              <label class="mb-0">Events</label>
              <p class="text-muted mb-2">Beperk toegang tot specifieke evenementen binnen de locatie.</p>
              <b-form-multiselect v-model="form.events" :options="eventsOptions" />
            </div>
          </div>

          <ValidationProvider rules="required|email|unique" v-slot="{ errors }">
            <div class="mb-3">
              <label class="required">E-mailadres</label>
              <b-form-input v-model="form.username" />
              <div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="required" v-slot="{ errors }">
            <div class="mb-3">
              <label class="required">Wachtwoord</label>
              <b-form-input v-model="form.password" type="text" />
              <div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
            </div>
          </ValidationProvider>

          <div class="mb-3">
            <b-form-checkbox v-model="form.is_send_email" class="pl-1">
              Ja, stuur een e-mail met het wachtwoord.
            </b-form-checkbox>
          </div>
        </b-card>
      </ValidationObserver>

      <div class="clearfix">
        <b-button @click="saveTeam" variant="primary" class="float-right">
          Toevoegen
          <font-awesome-icon icon="fa-solid fa-chevron-right" />
        </b-button>
      </div>

    </b-container>
  </div>
</template>

<script>
  import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
  import BFormMultiselect from '@/components/BFormMultiselect'

  export default {
      metaInfo: {
          title: 'Teamlid toevoegen',
      },
      components: {
        ValidationObserver,
        ValidationProvider,
        BFormMultiselect,
      },
      data() {
          return {
            showExplainRoles: false,
            form: {
              firstname: null,
              lastname: null,
              role: 'none',
              locations: [],
              events: [],
              username: null,
              is_send_email: true,
            },
            roleOptions: [
              { text: 'Geen', value: 'none' },
              { text: 'Administrator', value: 'administrator' },
              { text: 'Manager', value: 'manager' },
              { text: 'Servicemedewerker', value: 'service' },
              { text: 'Scan- en kassamedewerker', value: 'scanner' },
            ],
            locations: [],
          }
      },
      computed: {
        locationsOptions() {
          let obj = [];
          this.locations.forEach(
            item => {
              obj.push({ value: item.id, text: item.name });
            }
          );

          return obj;
        },
        eventsOptions() {
          let obj = [];
          this.events.forEach(
            item => {
              if (this.form.locations.find( loc => loc == item.location_id)) {
                obj.push({ value: item.id, text: item.name });
              }
            }
          );

          return obj;
        }
      },
      methods: {
        toggleInfo: function() {
          if (this.showExplainRoles) {
            this.showExplainRoles = false;
          } else {
            this.showExplainRoles = true;
          }
        },
        getLocations: function() {
          this.$axios.get("https://api.tixgo.nl/locations")
            .then( response => {
              this.locations = response.data;
          }).catch(response => { console.log(response); });
        },
        getEvents: function() {
          this.$axios.get("https://api.tixgo.nl/events")
            .then( response => {
              this.events = response.data.data;
          }).catch(response => { console.log(response); });
        },
        filterEvents: function() {
          // To be improved;
          this.form.events = [];
        },
        async saveTeam() {
          
          let check = await this.$refs['form'].validate();

          if (!check) {
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            
            return;
          }

          this.$axios.post("https://api.tixgo.nl/teams", this.form)
              .then( response => {
                response;
              this.$router.push('/manage/organisation/team')
          });
        }
      },
      created() {
        this.getLocations();
        this.getEvents();
        
        const isUnique = value =>
          new Promise(resolve => {
            this.$axios.get("https://api.tixgo.nl/teams?filter[username]=" + value)
            .then( response => {
              if (Object.keys(response.data).length == 0) {
                return resolve({
                  valid: true
                });
              }

              return resolve({
                valid: false,
                data: {
                  message: `${value} is already taken.`
                }
              });
            }).catch(response => { console.log(response); });
          });

        extend("unique", {
          validate: isUnique,
          message: 'Dit e-mailadres is reeds in gebruik.',
          getMessage: (field, params, data) => data.message
        });
      }
  }
</script>